import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["element"];
  static optInTargets = ["nav"];

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
    );

    this.elementTargets.forEach((el) => this.observer.observe(el));

    this.setupNavObserver();
    this.lastScrollY = 0;
    this.handleScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  disconnect() {
    this.observer.disconnect();
    if (this.navObserver) this.navObserver.disconnect();
    window.removeEventListener("scroll", this.handleScroll);
  }

  setupNavObserver() {
    const nav = this.navTarget;
    if (!nav) return;

    const sections = document.querySelectorAll("[data-section-theme]");

    this.navObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
            const theme = entry.target.dataset.sectionTheme;
            this.updateNavTheme(nav, theme);
          }
        });
      },
      { threshold: 0.1, rootMargin: "-80px 0px -80% 0px" },
    );

    sections.forEach((section) => this.navObserver.observe(section));
  }

  updateNavTheme(nav, theme) {
    nav.classList.remove(
      "bg-white/90",
      "bg-transparent",
      "bg-midnight/90",
      "bg-lime/90",
      "bg-cream/90",
      "bg-charcoal/90",
      "text-charcoal",
      "text-white",
      "backdrop-blur-md",
      "border-b",
      "border-neutral-200",
      "border-white/10",
    );

    switch (theme) {
      case "white":
        nav.classList.add(
          "bg-white/90",
          "backdrop-blur-md",
          "text-charcoal",
          "border-b",
          "border-neutral-200",
        );
        break;
      case "lime":
        nav.classList.add("bg-lime/90", "backdrop-blur-md", "text-charcoal");
        break;
      case "cream":
        nav.classList.add(
          "bg-cream/90",
          "backdrop-blur-md",
          "text-charcoal",
          "border-b",
          "border-neutral-200",
        );
        break;
      case "midnight":
        nav.classList.add(
          "bg-midnight/90",
          "backdrop-blur-md",
          "text-white",
          "border-b",
          "border-white/10",
        );
        break;
      case "charcoal":
        nav.classList.add(
          "bg-charcoal/90",
          "backdrop-blur-md",
          "text-white",
          "border-b",
          "border-white/10",
        );
        break;
      default:
        nav.classList.add("bg-white/90", "backdrop-blur-md", "text-charcoal");
    }
  }

  onScroll() {
    const nav = this.navTarget;
    if (!nav) return;

    const scrollY = window.scrollY;
    if (scrollY > 100) {
      nav.classList.add("shadow-lg");
    } else {
      nav.classList.remove("shadow-lg");
    }
    this.lastScrollY = scrollY;
  }
}
